// extracted by mini-css-extract-plugin
module.exports = {"subHeroImg":"styles-module--sub-hero-img--2KAtU"};